import { ActionEntityType } from '@pmp/api';

/** Where a change came from. Origin is a badge on every log entry. */
export enum ChangeOrigin {
  /** A lender user in the portal. Which portal that is depends on the entity, see `getOriginList`. */
  PORTAL = 'PORTAL',
  BROKER_PORTAL = 'BROKER_PORTAL',
  FCA = 'FCA',
}

/** Tag cells take `{ key, value }`: the key selects the styling, the value is the label. */
export type ChangeLogTag = {
  key: string;
  value: string;
};

/** One field that a change touched, shown in the expanded detail of its row. */
export type ChangeLogFieldChange = {
  id: string;
  /** Model field name. Dotted for a field of a collection, as `tradingAddresses.postCode`. */
  field: string;
  /** The row of a collection this field belongs to, absent for the record's own fields. */
  item?: string | null;
  /** Null when the field held nothing on that side of the change. */
  previousValue: string | null;
  newValue: string | null;
};

/** What one collection inside the record gained, lost or changed. */
export type ChangeLogCollectionChange = {
  /** The field the collection travels in, e.g. `tradingAddresses`. */
  field: string;
  changes: ChangeLogFieldChange[];
};

/** One change: everything a single author applied at one moment, over one or more fields. */
export type ChangeLogEntry = {
  id: string;
  changedBy: string;
  changedAt: string | null;
  origin: ChangeLogTag;
  /** Set only for changes that came through a change request, so Portal changes only. */
  changeRequestId: string | null;
  /** Field names this change touched, a collection counting as one. Drives the Fields column and its filter. */
  fields: string[];
  /** The record's own fields. A collection's rows are in `collections`, which renders as its own table. */
  changes: ChangeLogFieldChange[];
  collections: ChangeLogCollectionChange[];
};

export type ChangeLogTarget = {
  /** The entities the log covers, which is what `RESULT_CALLS` and `ID_FIELDS` know how to read. */
  entityType: ActionEntityType.BROKERS | ActionEntityType.LENDER_FIRMS | ActionEntityType.PRODUCTS | ActionEntityType.PROCURATION_FEES;
  id: string;
  name: string;
};

export type ChangeLogState = {
  open: boolean;
  target: ChangeLogTarget | null;
};
